
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nm/news/dirty-little-secret",
      function () {
        return require("private-next-pages/nm/news/dirty-little-secret.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nm/news/dirty-little-secret"])
      });
    }
  